import { render, staticRenderFns } from "./CustomEmptyLegsAndSpacesList.vue?vue&type=template&id=74f06462&"
import script from "./CustomEmptyLegsAndSpacesList.vue?vue&type=script&lang=js&"
export * from "./CustomEmptyLegsAndSpacesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports